import { useVenues } from 'contexts/VenueContext';
import { VenueInfoHeader } from 'venue/components/SingleVenue/VenueInfo/VenueInfoHeader';

interface VenueInfoBarInterface {
  isOnCheckoutPage?: boolean;
}

export const VenueInfoBar: React.FC<VenueInfoBarInterface> = ({
  isOnCheckoutPage = false,
}) => {
  const { selectedVenue } = useVenues();

  return selectedVenue ? (
    <div className="venue-info-bar">
      <VenueInfoHeader
        isOnCheckoutPage={isOnCheckoutPage}
        venue={selectedVenue}
        isTitleLink={true}
      />
    </div>
  ) : null;
};
